export default "__VITE_PUBLIC_ASSET__5e1aed67__"